module.exports = "/images/real-living.png?a178d0f75edfe5e6deb9c355574ff50e";